/**
 * Agreement Server
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { ErrorModel } from '../model/errorModel';
// @ts-ignore
import { PaymentForm } from '../model/paymentForm';
// @ts-ignore
import { PlanInfo } from '../model/planInfo';
// @ts-ignore
import { PlanPrice } from '../model/planPrice';
// @ts-ignore
import { ResponseMessage } from '../model/responseMessage';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PlansServiceInterface
} from './plans.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PlansService extends BaseService implements PlansServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Get plan payment form for user
     * @param conversationId The given id of payment request
     * @param token token for the transaction
     * @param locale Payment locale
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public paymentCallbackIyzicoPost(conversationId: string, token: string, locale?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html', context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public paymentCallbackIyzicoPost(conversationId: string, token: string, locale?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public paymentCallbackIyzicoPost(conversationId: string, token: string, locale?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'text/html', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public paymentCallbackIyzicoPost(conversationId: string, token: string, locale?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'text/html', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (conversationId === null || conversationId === undefined) {
            throw new Error('Required parameter conversationId was null or undefined when calling paymentCallbackIyzicoPost.');
        }
        if (token === null || token === undefined) {
            throw new Error('Required parameter token was null or undefined when calling paymentCallbackIyzicoPost.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'text/html'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (locale !== undefined && locale !== null) {
            localVarFormParams = localVarFormParams.append('locale', <any>locale) as any || localVarFormParams;
        }
        if (conversationId !== undefined && conversationId !== null) {
            localVarFormParams = localVarFormParams.append('conversationId', <any>conversationId) as any || localVarFormParams;
        }
        if (token !== undefined && token !== null) {
            localVarFormParams = localVarFormParams.append('token', <any>token) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/payment/callback/iyzico`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get plan prices.
     * @param accessToken System access token
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public plansGet(accessToken: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PlanInfo>;
    public plansGet(accessToken: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PlanInfo>>;
    public plansGet(accessToken: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PlanInfo>>;
    public plansGet(accessToken: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling plansGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/plans`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanInfo>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get plan payment form for user
     * @param accessToken System access token
     * @param planId The id of the plan
     * @param period Payment period for the plan
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public plansPlanIdPaymentFormPeriodGet(accessToken: string, planId: string, period: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PaymentForm>;
    public plansPlanIdPaymentFormPeriodGet(accessToken: string, planId: string, period: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PaymentForm>>;
    public plansPlanIdPaymentFormPeriodGet(accessToken: string, planId: string, period: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PaymentForm>>;
    public plansPlanIdPaymentFormPeriodGet(accessToken: string, planId: string, period: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling plansPlanIdPaymentFormPeriodGet.');
        }
        if (planId === null || planId === undefined) {
            throw new Error('Required parameter planId was null or undefined when calling plansPlanIdPaymentFormPeriodGet.');
        }
        if (period === null || period === undefined) {
            throw new Error('Required parameter period was null or undefined when calling plansPlanIdPaymentFormPeriodGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/plans/${this.configuration.encodeParam({name: "planId", value: planId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/paymentForm/${this.configuration.encodeParam({name: "period", value: period, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PaymentForm>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Change plan of subscription
     * @param accessToken System access token.
     * @param planName The name of the updated plan
     * @param period Payment period for the plan
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionsPlanPut(accessToken: string, planName?: string, period?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public subscriptionsPlanPut(accessToken: string, planName?: string, period?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public subscriptionsPlanPut(accessToken: string, planName?: string, period?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public subscriptionsPlanPut(accessToken: string, planName?: string, period?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling subscriptionsPlanPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (planName !== undefined && planName !== null) {
            localVarFormParams = localVarFormParams.append('planName', <any>planName) as any || localVarFormParams;
        }
        if (period !== undefined && period !== null) {
            localVarFormParams = localVarFormParams.append('period', <any>period) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/subscriptions/plan`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update card and invoice for ongoing subscription. No payment and price required
     * @param accessToken System access token.
     * @param cardHolderName Name on card
     * @param cardNumber Name on card
     * @param expireYear Name on card
     * @param expireMonth Name on card
     * @param cvc Name on card
     * @param address Name on card
     * @param zipCode Name on card
     * @param city Name on card
     * @param province Province
     * @param country Country
     * @param taxOffice Office
     * @param taxNumber Number
     * @param invoiceType Name on card
     * @param title Name on card
     * @param individualName Name on card
     * @param citizenId Citizen ID
     * @param state state
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionsPut(accessToken: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, state?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public subscriptionsPut(accessToken: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, state?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public subscriptionsPut(accessToken: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, state?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public subscriptionsPut(accessToken: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, state?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling subscriptionsPut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (cardHolderName !== undefined && cardHolderName !== null) {
            localVarFormParams = localVarFormParams.append('cardHolderName', <any>cardHolderName) as any || localVarFormParams;
        }
        if (cardNumber !== undefined && cardNumber !== null) {
            localVarFormParams = localVarFormParams.append('cardNumber', <any>cardNumber) as any || localVarFormParams;
        }
        if (expireYear !== undefined && expireYear !== null) {
            localVarFormParams = localVarFormParams.append('expireYear', <any>expireYear) as any || localVarFormParams;
        }
        if (expireMonth !== undefined && expireMonth !== null) {
            localVarFormParams = localVarFormParams.append('expireMonth', <any>expireMonth) as any || localVarFormParams;
        }
        if (cvc !== undefined && cvc !== null) {
            localVarFormParams = localVarFormParams.append('cvc', <any>cvc) as any || localVarFormParams;
        }
        if (address !== undefined && address !== null) {
            localVarFormParams = localVarFormParams.append('address', <any>address) as any || localVarFormParams;
        }
        if (zipCode !== undefined && zipCode !== null) {
            localVarFormParams = localVarFormParams.append('zipCode', <any>zipCode) as any || localVarFormParams;
        }
        if (city !== undefined && city !== null) {
            localVarFormParams = localVarFormParams.append('city', <any>city) as any || localVarFormParams;
        }
        if (province !== undefined && province !== null) {
            localVarFormParams = localVarFormParams.append('province', <any>province) as any || localVarFormParams;
        }
        if (country !== undefined && country !== null) {
            localVarFormParams = localVarFormParams.append('country', <any>country) as any || localVarFormParams;
        }
        if (taxOffice !== undefined && taxOffice !== null) {
            localVarFormParams = localVarFormParams.append('taxOffice', <any>taxOffice) as any || localVarFormParams;
        }
        if (taxNumber !== undefined && taxNumber !== null) {
            localVarFormParams = localVarFormParams.append('taxNumber', <any>taxNumber) as any || localVarFormParams;
        }
        if (invoiceType !== undefined && invoiceType !== null) {
            localVarFormParams = localVarFormParams.append('invoiceType', <any>invoiceType) as any || localVarFormParams;
        }
        if (title !== undefined && title !== null) {
            localVarFormParams = localVarFormParams.append('title', <any>title) as any || localVarFormParams;
        }
        if (individualName !== undefined && individualName !== null) {
            localVarFormParams = localVarFormParams.append('individualName', <any>individualName) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizenId', <any>citizenId) as any || localVarFormParams;
        }
        if (state !== undefined && state !== null) {
            localVarFormParams = localVarFormParams.append('state', <any>state) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/subscriptions`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Upgrade from Trial for FREE plan. Price is required and should match with server plan price. Price will be withdrawn
     * @param accessToken System access token.
     * @param planName The name of the updated plan
     * @param period Payment period for the plan
     * @param price Amount that will be paid now. For check purposes.
     * @param cardHolderName Name on card
     * @param cardNumber Name on card
     * @param expireYear Name on card
     * @param expireMonth Name on card
     * @param cvc Name on card
     * @param address Name on card
     * @param zipCode Name on card
     * @param city Name on card
     * @param province Province
     * @param country Country
     * @param taxOffice Office
     * @param taxNumber Number
     * @param invoiceType Name on card
     * @param title Name on card
     * @param individualName Name on card
     * @param citizenId Name on card
     * @param discountCoupon Discount coupon
     * @param state state
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public subscriptionsUpgradePut(accessToken: string, planName?: string, period?: string, price?: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, discountCoupon?: string, state?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<ResponseMessage>;
    public subscriptionsUpgradePut(accessToken: string, planName?: string, period?: string, price?: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, discountCoupon?: string, state?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<ResponseMessage>>;
    public subscriptionsUpgradePut(accessToken: string, planName?: string, period?: string, price?: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, discountCoupon?: string, state?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<ResponseMessage>>;
    public subscriptionsUpgradePut(accessToken: string, planName?: string, period?: string, price?: string, cardHolderName?: string, cardNumber?: string, expireYear?: string, expireMonth?: string, cvc?: string, address?: string, zipCode?: string, city?: string, province?: string, country?: string, taxOffice?: string, taxNumber?: string, invoiceType?: string, title?: string, individualName?: string, citizenId?: string, discountCoupon?: string, state?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling subscriptionsUpgradePut.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/x-www-form-urlencoded'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (planName !== undefined && planName !== null) {
            localVarFormParams = localVarFormParams.append('planName', <any>planName) as any || localVarFormParams;
        }
        if (period !== undefined && period !== null) {
            localVarFormParams = localVarFormParams.append('period', <any>period) as any || localVarFormParams;
        }
        if (price !== undefined && price !== null) {
            localVarFormParams = localVarFormParams.append('price', <any>price) as any || localVarFormParams;
        }
        if (cardHolderName !== undefined && cardHolderName !== null) {
            localVarFormParams = localVarFormParams.append('cardHolderName', <any>cardHolderName) as any || localVarFormParams;
        }
        if (cardNumber !== undefined && cardNumber !== null) {
            localVarFormParams = localVarFormParams.append('cardNumber', <any>cardNumber) as any || localVarFormParams;
        }
        if (expireYear !== undefined && expireYear !== null) {
            localVarFormParams = localVarFormParams.append('expireYear', <any>expireYear) as any || localVarFormParams;
        }
        if (expireMonth !== undefined && expireMonth !== null) {
            localVarFormParams = localVarFormParams.append('expireMonth', <any>expireMonth) as any || localVarFormParams;
        }
        if (cvc !== undefined && cvc !== null) {
            localVarFormParams = localVarFormParams.append('cvc', <any>cvc) as any || localVarFormParams;
        }
        if (address !== undefined && address !== null) {
            localVarFormParams = localVarFormParams.append('address', <any>address) as any || localVarFormParams;
        }
        if (zipCode !== undefined && zipCode !== null) {
            localVarFormParams = localVarFormParams.append('zipCode', <any>zipCode) as any || localVarFormParams;
        }
        if (city !== undefined && city !== null) {
            localVarFormParams = localVarFormParams.append('city', <any>city) as any || localVarFormParams;
        }
        if (province !== undefined && province !== null) {
            localVarFormParams = localVarFormParams.append('province', <any>province) as any || localVarFormParams;
        }
        if (country !== undefined && country !== null) {
            localVarFormParams = localVarFormParams.append('country', <any>country) as any || localVarFormParams;
        }
        if (taxOffice !== undefined && taxOffice !== null) {
            localVarFormParams = localVarFormParams.append('taxOffice', <any>taxOffice) as any || localVarFormParams;
        }
        if (taxNumber !== undefined && taxNumber !== null) {
            localVarFormParams = localVarFormParams.append('taxNumber', <any>taxNumber) as any || localVarFormParams;
        }
        if (invoiceType !== undefined && invoiceType !== null) {
            localVarFormParams = localVarFormParams.append('invoiceType', <any>invoiceType) as any || localVarFormParams;
        }
        if (title !== undefined && title !== null) {
            localVarFormParams = localVarFormParams.append('title', <any>title) as any || localVarFormParams;
        }
        if (individualName !== undefined && individualName !== null) {
            localVarFormParams = localVarFormParams.append('individualName', <any>individualName) as any || localVarFormParams;
        }
        if (citizenId !== undefined && citizenId !== null) {
            localVarFormParams = localVarFormParams.append('citizenId', <any>citizenId) as any || localVarFormParams;
        }
        if (discountCoupon !== undefined && discountCoupon !== null) {
            localVarFormParams = localVarFormParams.append('discountCoupon', <any>discountCoupon) as any || localVarFormParams;
        }
        if (state !== undefined && state !== null) {
            localVarFormParams = localVarFormParams.append('state', <any>state) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/subscriptions/upgrade`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<ResponseMessage>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get plan price for user.
     * @param accessToken System access token
     * @param id the ID of the plan
     * @param period the period of the plan. Values: Monthly | Yearly
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public userPlansIdPeriodGet(accessToken: string, id: string, period: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PlanPrice>;
    public userPlansIdPeriodGet(accessToken: string, id: string, period: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PlanPrice>>;
    public userPlansIdPeriodGet(accessToken: string, id: string, period: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PlanPrice>>;
    public userPlansIdPeriodGet(accessToken: string, id: string, period: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (accessToken === null || accessToken === undefined) {
            throw new Error('Required parameter accessToken was null or undefined when calling userPlansIdPeriodGet.');
        }
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling userPlansIdPeriodGet.');
        }
        if (period === null || period === undefined) {
            throw new Error('Required parameter period was null or undefined when calling userPlansIdPeriodGet.');
        }

        let localVarHeaders = this.defaultHeaders;
        if (accessToken !== undefined && accessToken !== null) {
            localVarHeaders = localVarHeaders.set('access_token', String(accessToken));
        }

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/user/plans/${this.configuration.encodeParam({name: "id", value: id, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "period", value: period, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PlanPrice>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
